import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ResourceLoading } from "../../../../components/utils/ResourceLoading";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import {
  deleteHourRateAsync,
  getHourRateAsync,
} from "../../../../slices/offer-calculation-hour-rate";
import DashboardHeader from "../../../../components/dashboard/dashboardHeader";
import { FolderIcon, TrashIcon } from "@heroicons/react/24/outline";
import { dispatchWithToast } from "../../../../components/Utils";
import ProConfirmation from "../../../../components/utils/ProConfirmation";
import { ResourceError } from "../../../../components/utils/ResourceError";
import { OfferCalculationHourRateInfo } from "../../../../components/dashboard/offers/hour-rates/hour-rate-info";

export const OfferCalculationHourRate = (props) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const itemState = {
    ...useSelector((store) => {
      return store.offerCalculationHourRates;
    }),
  };
  const { isLoading, error, errors, hourRate } = itemState;

  const [deletePromptOpen, setDeletePromptOpen] = useState(false);

  useEffect(() => {
    if (id && id !== "new") {
      dispatch(getHourRateAsync(id));
    }
  }, [dispatch, id]);

  const handleDeletePrompt = () => {
    setDeletePromptOpen(true);
  };

  const navigate = useNavigate();

  const handleAfterDispatch = () => {
    setDeletePromptOpen(false);
    navigate("/dashboard/offers/hour-rates");
  };

  const handleDeleteItem = () => {
    dispatchWithToast(dispatch(deleteHourRateAsync(hourRate?.id)), null, () =>
      handleAfterDispatch(false)
    );
  };

  const headerActions = [
    {
      component: null,
      label: t("Kopier"),
      description: "",
      path: null,
      action: null,
      icon: FolderIcon,
      textColor: "text-teal-700",
      bgColor: "",
      hidden: isLoading,
      menu: true,
    },
    {
      component: null,
      label: t("Delete"),
      description: "",
      path: null,
      action: () => handleDeletePrompt(hourRate),
      icon: TrashIcon,
      textColor: "text-teal-700",
      bgColor: "",
      hidden: isLoading,
      menu: true,
    },
  ];

  const renderContent = () => {
    if (isLoading) {
      return <ResourceLoading />;
    }
    if (error && errors) {
      return <ResourceError errors={errors} />;
    }

    return (
      <Grid container spacing={3}>
        <Grid
          container
          item
          lg={12}
          spacing={3}
          sx={{ height: "fit-content", order: { md: 2, xs: 1 } }}
        >
          <Grid item xs={12}>
            <OfferCalculationHourRateInfo hourRate={hourRate} />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <DashboardHeader
        subtitle=""
        actions={headerActions}
        title={hourRate?.id ? hourRate?.title : t("Ny timesats")}
      >
        <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
          <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
            {renderContent()}
          </div>
        </div>
      </DashboardHeader>

      <ProConfirmation
        severity="confirmation"
        open={deletePromptOpen}
        message={t("Denne timesatsen vil bli fjernet for godt og kan ikke reverseres")}
        action="delete"
        module="offer_calculation_hour_rate"
        yesCallback={() => handleDeleteItem()}
        cancelCallback={() => setDeletePromptOpen(false)}
      />
    </>
  );
};

